import React, { useState, useEffect } from "react";

export default function Preloader() {
  const [progress, setProgress] = useState(0);
  const [hidden, setHidden] = useState(false);
  const [fade, setFade] = useState(false);

  useEffect(() => {
    let current = 0;
    const timer = setInterval(() => {
      current += Math.floor(Math.random() * 8) + 4;
      if (current >= 100) {
        current = 100;
        setProgress(100);
        clearInterval(timer);
        setTimeout(() => setFade(true), 300);
        setTimeout(() => setHidden(true), 900);
      } else {
        setProgress(current);
      }
    }, 40);

    return () => clearInterval(timer);
  }, []);

  if (hidden) return null;

  return (
    <div
      className={`fixed inset-0 z-[999999] bg-[#05070d]/85 backdrop-blur-2xl flex flex-col items-center justify-center select-none transition-all duration-700 ${
        fade ? "opacity-0 pointer-events-none scale-105" : "opacity-100 scale-100"
      }`}
      data-testid="indungi-preloader"
    >
      {/* Background Cyber Scanlines & Grid */}
      <div 
        className="absolute inset-0 pointer-events-none opacity-20"
        style={{
          backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px)",
          backgroundSize: "36px 36px"
        }}
      />
      <div 
        className="absolute inset-0 pointer-events-none opacity-10"
        style={{
          backgroundImage: "repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(255, 79, 0, 0.4) 2px, rgba(255, 79, 0, 0.4) 4px)"
        }}
      />

      <div className="relative z-10 flex flex-col items-center max-w-4xl px-4 text-center">
        
        {/* Main Text Fill Effect (Xports Style) */}
        <div className="relative font-chakra font-black text-4xl sm:text-7xl lg:text-8xl tracking-wider uppercase inline-block select-none my-4">
          
          {/* Base Layer: Hollow Stroke Text */}
          <div 
            className="text-transparent whitespace-nowrap"
            style={{
              WebkitTextStroke: "2px rgba(255, 255, 255, 0.25)",
              letterSpacing: "0.08em"
            }}
          >
            INDUNGI ROMÂNIA
          </div>

          {/* Top Layer: Filled Animated Text wiping left-to-right based on progress */}
          <div 
            className="absolute top-0 left-0 bottom-0 overflow-hidden whitespace-nowrap transition-all duration-100 ease-out"
            style={{ 
              width: `${progress}%`,
              borderRight: progress < 100 ? "3px solid #FF4F00" : "none",
              boxShadow: progress < 100 ? "5px 0 20px rgba(255, 79, 0, 0.9)" : "none"
            }}
          >
            <div 
              className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF4F00] via-amber-400 to-[#00ff88]"
              style={{
                letterSpacing: "0.08em",
                filter: "drop-shadow(0 0 25px rgba(255, 79, 0, 0.75))"
              }}
            >
              INDUNGI ROMÂNIA
            </div>
          </div>

        </div>

        {/* Counter & Subtitle Bar */}
        <div className="w-full max-w-md space-y-3 pt-2">
          {/* Progress percentage & Status */}
          <div className="flex items-center justify-between text-xs sm:text-sm font-mono">
            <span className="text-zinc-400 flex items-center gap-2 uppercase tracking-widest text-[10px] sm:text-xs">
              <span className="w-2 h-2 rounded-full bg-[#FF4F00] animate-ping" />
              <span>ESPORTS & GAMING NETWORK · EST. 2010</span>
            </span>
            <span className="font-chakra font-black text-amber-400 text-base sm:text-lg">
              {progress}%
            </span>
          </div>

          {/* Bottom Neon Accent Line */}
          <div className="w-full h-1.5 bg-black/60 rounded-full overflow-hidden p-0.5 border border-white/10 shadow-inner">
            <div 
              className="h-full rounded-full bg-gradient-to-r from-[#FF4F00] via-amber-400 to-[#00ff88] transition-all duration-100 ease-out shadow-[0_0_12px_rgba(255,79,0,0.8)]"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>

      </div>
    </div>
  );
}
